import { ApiError } from './generated-client';

// eslint-disable-next-line arrow-body-style
export const getErrorMessage = (e: unknown, defaultMessage = 'Something went wrong'): string => {
  const { message, detail } = (e as ApiError).body ?? (e as Error);

  if (typeof detail !== 'string' && detail !== undefined) {
    return String(detail);
  }

  if (typeof message !== 'string' && message !== undefined) {
    return String(message);
  }

  return detail || message || defaultMessage;
};

export const getErrorCode = (e: unknown): number | null => {
  if (typeof e !== 'object' || e == null) {
    return null;
  }

  if ('code' in e) {
    return e.code as number;
  }

  return null;
};
